import React, { useState } from 'react'
import { Button, Card, Drawer, notification, Select } from 'antd'
import { useDispatch } from 'react-redux'
import { InputBox,getPreviousAbstractStatuses } from '../../../components/_utils/appUtils'
import { updateAbstractStatusFxn } from './actions'

const { Option } = Select;

const UpdateStatusDrawer = (props) => {
  let { visible, onClose, abstract, onSubmit } = props
  let dispatch = useDispatch()
  let statusList = getPreviousAbstractStatuses(abstract.status)
  // const statusList = [
  //   'Submitted Abstract',
  //   'Abstract Under Review',
  //   'Reviewed Comments',
  //   'Comments To Author',
  //   'Revised Abstract',
  //   'Approved',
  //   'Deleted',
  //   'Withdrawn'
  // ];

  let [status, setStatus] = useState(abstract.status || '')

  const updateStatus = async () => {
    if (!status) {
      notification.warning({ message: 'Please choose a status.' })
      return
    }

    let obj = {
      status,
      abstractId: abstract._id
    }

    let { success, data } = await dispatch(updateAbstractStatusFxn(obj))
    if (success) {
      // notification.success({ message: 'Status updated successfully' })
      onSubmit(data)
      onClose();
    }
  }

  return (
    <Drawer
      // 🟢 Changed from onlineAbstractId to abstractNo
      title={`Update Status | Abstract No. - ${abstract.abstractNo || 'N/A'}`}
      visible={visible}
      width={'35%'}
      onClose={onClose}>
      <Card>
        <InputBox title={'Status'} bordered={false}>
          <Select
            style={{ width: '100%' }}
            onChange={(val) => setStatus(val)}
            value={status || undefined}>
            {statusList && statusList.map((item, key) => (
              <Option value={item.status} key={key}>
                {item.status}
              </Option>
            ))}
          </Select>
        </InputBox>
        <Button
          type='primary'
          onClick={updateStatus}
          style={{ marginTop: 20 }}>
          Submit
        </Button>
      </Card>
    </Drawer>
  )
}

export default UpdateStatusDrawer
